export enum DocumentStatus {
    NONE = 'none',
    LOADED = 'loaded',
    LOADING = 'loading',
    ERROR = 'error',
    LOCAL = 'local',
}
